import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["hasPermissionToManageClients"]),
    isWhistleAdmin() {
      return this.hasPermissionToManageClients();
    },
  },
};
